import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Carousel from 'react-bootstrap/Carousel';

const VideoPlayer = ({ data }) => {
 const videos = data.videos;

 return (
  <div>
   <h3>לקוחות מרוצים</h3>
   <Container>
    <Row>
     <Col>
      <Carousel controls={true} fade>
       {videos.map((video, index) => (
        <Carousel.Item key={index} interval={30000}>
         <div className='ratio ratio-16x9'>
          <video
           autoPlay
           loop
           muted
           preload='auto'
           controls
           playsInline
           className='w-100 h-100'>
           <source src={video} type='video/mp4' />
           Your browser does not support the video tag.
          </video>
         </div>
        </Carousel.Item>
       ))}
      </Carousel>
     </Col>
    </Row>
   </Container>
  </div>
 );
};

export default VideoPlayer;
